<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12" md="6" sm="12">
        <base-material-card
          color="success"
          icon="mdi-chair-school"
          title="Edit Course"
          class="px-5 py-3"
        >
          <v-form ref="form" class="mt-5">
            <v-autocomplete
              v-model="course.teacherIds"
              label="Teacher"
              :items="teachers"
              item-text="name"
              item-value="id"
              multiple
            />

            <v-autocomplete
              v-model="course.trainingTemplateId"
              :disabled="disableTrainingChange()"
              label="Template"
              :items="templates"
              :rules="[rules.required]"
              item-text="description"
              item-value="id"
            />

            <v-datetime-picker label="Start" v-model="course.start" :time-picker-props="timeProps">
              <template slot="dateIcon">
                <v-icon>mdi-calendar</v-icon>
              </template>
              <template slot="timeIcon">
                <v-icon>mdi-calendar-clock</v-icon>
              </template>
            </v-datetime-picker>
            <v-datetime-picker label="End" v-model="course.end" :time-picker-props="timeProps">
              <template slot="dateIcon">
                <v-icon>mdi-calendar</v-icon>
              </template>
              <template slot="timeIcon">
                <v-icon>mdi-calendar-clock</v-icon>
              </template>
            </v-datetime-picker>
            <v-text-field v-model="course.adress" label="Adress" :rules="[rules.required]" />
            <v-text-field v-model="course.zipCode" label="Zip Code" :rules="[rules.required]" />
            <v-text-field v-model="course.city" label="City" :rules="[rules.required]" />
            <v-text-field
              v-model.number="course.availableSeats"
              label="Seats"
              :rules="[rules.required]"
            />
            <v-img class="mt-5 mb-5" :src="course.imagePath" max-height="250" contain />
            <v-file-input
              class="mb-2"
              v-bind:success="uploadStatus"
              v-bind:success-messages="uploadText"
              @change="onChangedImage"
              v-model="selectedImage"
              accept="image/*"
              label="File input"
              show-size
            ></v-file-input>
            <v-btn class="mb-5" @click="onUpload">Upload</v-btn>

            <v-textarea v-model="course.description" name="input-7-1" label="Description"></v-textarea>

            <v-switch v-model="course.public" label="Public"></v-switch>

            <v-divider />

            <v-row>
              <v-col cols="12" md="3" sm="12">
                <v-list>
                  <v-subheader>Course tasks</v-subheader>
                  <v-list-item v-for="(task,i) in course.template.trainingTasks" :key="i">
                    <v-switch
                      :input-value="isTrainingTaskCompleted(task)"
                      v-on:click="trainingTaskCompletedToggled(task)"
                      :label="task.name"
                      color="success"
                    ></v-switch>
                  </v-list-item>
                </v-list>
              </v-col>
            </v-row>
          </v-form>

          <v-card-actions class="pl-0">
            <v-row justify="center">
              <v-btn @click="update()" color="success" min-width="100">Update</v-btn>
            </v-row>
          </v-card-actions>
        </base-material-card>
      </v-col>
      <v-col cols="12" md="6" sm="12">
        <base-material-card
          color="success"
          icon="mdi-account-multiple"
          title="Booking"
          class="px-5 py-3"
        >
          <v-data-table
            :headers="bookingHeaders"
            :items="bookings"
            :search.sync="bookingSearch"
            :sort-desc="[true,false]"
            :expanded.sync="expanded"
            show-expand
            multi-sort
          >
            <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length">
                <v-subheader>General</v-subheader>
                <v-row class="ml-1">
                  <v-col cols="10">
                    <v-text-field v-model.number="item.models" label="Hairmodels" />
                    <v-text-field v-model.number="item.dolls" label="Dolls" />
                    <v-switch v-model="item.finished" label="Course completed" />
                  </v-col>
                </v-row>
                <v-divider />
                <v-row>
                  <v-col cols="12" md="3" sm="12">
                    <v-list>
                      <v-subheader>Customer tasks</v-subheader>
                      <v-list-item v-for="(task,i) in course.template.customerTasks" :key="i">
                        <v-switch
                          v-on:click="attendeeTaskCompletedToggled(task, item)"
                          :input-value="isAttendeeTaskCompleted(task, item)"
                          :label="task.name"
                          color="success"
                        ></v-switch>
                      </v-list-item>
                    </v-list>
                  </v-col>
                  <v-divider vertical></v-divider>
                  <v-col cols="12" md="8" sm="12">
                    <v-list>
                      <v-subheader>Attendees</v-subheader>
                      <v-list-item v-for="(attendee,i) in item.trainingBookingAttendes" :key="i">
                        <v-text-field label="Name" v-model="attendee.name" />
                        <v-text-field label="Email" v-model="attendee.email" />
                        <v-text-field label="Phone" v-model="attendee.phone" />
                        <v-icon @click="removeAttendee(item,i)">mdi-minus</v-icon>
                      </v-list-item>
                      <v-row justify="center">
                        <v-icon v-show="bookedSeats < seats" @click="addAttendee(item)">mdi-plus</v-icon>
                      </v-row>
                    </v-list>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-btn @click="updateBooking(item)" color="success" min-width="100">Update</v-btn>
                </v-row>
              </td>
            </template>

            <template v-slot:top>
              <v-row>
                <v-toolbar flat>
                  <v-row justify="end">
                    <v-col md="3" sm="2">
                      <HtTrainingBadge :seats="seats" :bookings="bookedSeats" />
                    </v-col>

                    <v-col md="3" sm="6">
                      <v-btn
                        v-show="seats > bookedSeats"
                        color="primary"
                        dark
                        class="mb-2"
                        @click.stop="showBooker=true"
                      >New Booking</v-btn>
                    </v-col>
                    <!-- <v-col md="3" sm="12"> -->
                    <HtTrainingBooking
                      v-on:bookingAdded="bookingAdded"
                      :trainingIdProp="course.id"
                      v-model="showBooker"
                    />
                    <!-- </v-col> -->
                  </v-row>
                </v-toolbar>
                <!-- <v-divider class="mt-3" /> -->
                <v-text-field
                  v-model="bookingSearch"
                  append-icon="mdi-magnify"
                  class="ml-auto"
                  label="Search"
                  hide-details
                  single-line
                  style="max-width: 250px;"
                />
              </v-row>
            </template>
          </v-data-table>
        </base-material-card>
      </v-col>
    </v-row>

    <div class="text-center ma-2">
      <v-snackbar v-model="snackbar.visible" :timeout="snackbar.timeout" :color="snackbar.color">
        {{ snackbar.snackbarText }}
        <v-btn dark text @click="snackbar.visible = false">Close</v-btn>
      </v-snackbar>
    </div>
  </v-container>
</template>

<script>
import TrainingApi from "../../../servcies/api/training/Training";
import TemplateApi from "../../../servcies/api/training/TrainingTemplate";
import BookingApi from "../../../servcies/api/training/TrainingBooking";
import TrainingBooking from "../../../servcies/api/training/TrainingBooking";
import TrainingCustomer from "../../../servcies/api/training/TrainingCustomer";
import HtTrainingBooking from "./Components/HtTrainingBooking";
import FileApi from "../../../servcies/api/File";
import router from "../../../router";
import _ from "lodash";

import HtTrainingBadge from "./Components/HtTrainingBadge";

export default {
  name: "TrainingEdit",
  components: {
    HtTrainingBooking,
    HtTrainingBadge
  },
  data: () => ({
    showBooker: false,

    selectedImage: null,
    uploadStatus: false,
    uploadText: "",
    dialog: false,
    courseId: undefined,
    course: undefined,
    bookings: [],
    bookingSearch: undefined,

    snackbar: {
      snackbarText: "",
      visible: false,
      timeout: 4000,
      color: "error"
    },

    expanded: [],

    teachers: [],
    templates: [],

    customers: [],
    trainings: [],

    rules: {
      required: value => !!value || "Required."
    },

    newBooking: {
      trainingBookingAttendes: [{ name: "", email: "", phone: "" }],
      customer: undefined,
      trainingId: undefined,
      message: "",
      models: undefined,
      dolls: undefined
    },

    timeProps: {
      format: "24hr"
    },

    bookingHeaders: [
      {
        text: "Name",
        value: "customer.name"
      },
      {
        text: "Phone",
        value: "customer.phoneNumber"
      },
      {
        text: "Email",
        value: "customer.email"
      },
      {
        text: "Attendees",
        value: "trainingBookingAttendes.length"
      },
      {
        text: "",
        value: "data-table-expand"
      }
    ]
  }),

  created() {
    if (this.$route.params.id) {
      this.courseId = this.$route.params.id;
      this.init();
    }
  },
  computed: {
    bookedSeats() {
      var seats = 0;
      _.forEach(this.bookings, item => {
        seats += item.trainingBookingAttendes.length;
      });

      return seats;
    },
    seats() {
      return this.course.availableSeats;
    }
  },
  methods: {
    isTrainingTaskCompleted(templateTask) {
      var result = false;
      _.forEach(this.course.trainingTasks, item => {
        if (item.templateTrainingTaskId == templateTask.id) {
          result = true;
        }
      });

      return result;
    },
    isAttendeeTaskCompleted(templateTask, attendee) {
      var result = false;
      _.forEach(attendee.trainingBookingTasks, item => {
        if (item.templateAttendeeTaskId == templateTask.id) {
          result = true;
          return true;
        }
      });

      return result;
    },

    trainingTaskCompletedToggled(templateTask) {
      let completed = this.isTrainingTaskCompleted(templateTask);

      if (completed) {
        this.course.trainingTasks = _.filter(
          this.course.trainingTasks,
          trainingTask => trainingTask.templateTrainingTaskId != templateTask.id
        );
      } else {
        this.course.trainingTasks.push({
          name: templateTask.name,
          templateTrainingTaskId: templateTask.id
        });
      }
    },
    attendeeTaskCompletedToggled(templateTask, attendee) {
      let completed = this.isAttendeeTaskCompleted(templateTask, attendee);

      if (completed) {
        attendee.trainingBookingTasks = _.filter(
          attendee.trainingBookingTasks,
          bookingTask => bookingTask.templateAttendeeTaskId != templateTask.id
        );
      } else {
        attendee.trainingBookingTasks.push({
          name: templateTask.name,
          templateAttendeeTaskId: templateTask.id
        });
      }
    },

    bookingAdded() {
      this.showBooker = false;
      this.getBookingbyTrainingId();
    },
    onChangedImage() {
      this.uploadStatus = false;
      this.uploadText = "";
    },
    onUpload() {
      if (this.selectedImage == null) return;

      if (!this.selectedImage.type.includes("image")) {
        this.snackbar.snackbarText = "Only images are allowed.";
        this.snackbar.visible = true;
      }
      var fileData = new FormData();
      fileData.append("file", this.selectedImage, this.selectedImage.name);

      FileApi.upload(fileData)
        .then(result => {
          //Set the guid to the image
          this.course.imageExtId = result.externalId;
          this.course.imagePath = result.filePath;
          this.uploadStatus = true;
          this.uploadText = "File uploadded";
        })
        .catch(err => {
          this.Snackbar.snackbarText = err;
          this.Snackbar.visible = true;
        });
    },

    addAttendee(item) {
      item.trainingBookingAttendes.push({
        name: "",
        email: "",
        phone: ""
      });
    },
    removeAttendee(item, index) {
      item.trainingBookingAttendes.splice(index, 1);
    },

    getBookingbyTrainingId() {
      let loaderBookingByTraining = this.$loading.show();
      TrainingBooking.GetBookingByTrainingId(this.courseId)
        .then(result => {
          this.bookings = result;
          loaderBookingByTraining.hide();
        })
        .catch(error => {
          this.Snackbar.snackbarText = error;
          this.Snackbar.visible = true;
          loaderBookingByTraining.hide();
        });
    },

    updateBooking(item) {
      let loaderBookingByTraining = this.$loading.show();
      BookingApi.UpdateBooking(item.id, item)
        .then(result => {
          loaderBookingByTraining.hide();
        })
        .catch(err => {
          this.Snackbar.snackbarText = err;
          this.Snackbar.visible = true;
          loaderBookingByTraining.hide();
        });
    },

    getNumberOfBookedSeats() {
      var bookedSeats = 0;
      _.forEach(this.bookings, item => {
        bookedSeats += item.trainingBookingAttendes.length;
      });
      return bookedSeats;
    },

    disableTrainingChange() {
      return this.getNumberOfBookedSeats() > 0;
    },

    init() {
      let loaderTeachers = this.$loading.show();

      this.getBookingbyTrainingId();
      TrainingApi.getTeachers()
        .then(result => {
          this.teachers = result;
          loaderTeachers.hide();
        })
        .catch(err => {
          this.Snackbar.snackbarText = err;
          this.Snackbar.visible = true;
          loaderTeachers.hide();
        });

      let loaderTemplates = this.$loading.show();
      TemplateApi.getTemplates()
        .then(result => {
          this.templates = result;
          loaderTemplates.hide();
        })
        .catch(err => {
          this.Snackbar.snackbarText = err;
          this.Snackbar.visible = true;
          loaderTemplates.hide();
        });

      let loaderTraining = this.$loading.show();
      TrainingApi.getTraining(this.courseId)
        .then(result => {
          this.course = result;
          this.course.start = new Date(result.start);
          this.course.end = new Date(result.end);
          loaderTraining.hide();
        })
        .catch(err => {
          this.Snackbar.snackbarText = err;
          this.Snackbar.visible = true;
          loaderTraining.hide();
        });

      let loaderCustomers = this.$loading.show();
      TrainingCustomer.GetCustomers()
        .then(result => {
          this.customers = result;
          loaderCustomers.hide();
        })
        .catch(error => {
          this.Snackbar.snackbarText = error;
          this.Snackbar.visible = true;
          loaderCustomers.hide();
        });

      let loaderTrainings = this.$loading.show();
      TrainingApi.getTrainings()
        .then(result => {
          this.trainings = result;
          loaderTrainings.hide();
        })
        .catch(err => {
          this.Snackbar.snackbarText = err;
          this.Snackbar.visible = true;
          loaderTrainings.hide();
        });
    },

    update() {
      if (this.$refs.form.validate()) {
        var bookedSeats = this.getNumberOfBookedSeats();

        if (bookedSeats > this.course.availableSeats) {
          this.snackbar.snackbarText =
            "Number of booked seats cannot be higher than number of available seats!";
          this.snackbar.visible = true;
          return;
        }

        if (!this.course.start || !this.course.end) {
          this.snackbar.snackbarText = "Enter start and end dates!";
          this.snackbar.visible = true;
          return;
        }
        var startTime = new Date(this.course.start).getTime();
        var endDate = new Date(this.course.end).getTime();

        if (startTime >= endDate) {
          this.snackbar.snackbarText = "Start date must be before end date!";
          this.snackbar.visible = true;
          return;
        }

        let loader = this.$loading.show();
        TrainingApi.updateTraining(this.course.id, this.course)
          .then(result => {
            this.$router.push({ path: "/course/course" });
            loader.hide();
          })
          .catch(err => {
            this.Snackbar.snackbarText = err;
            this.Snackbar.visible = true;
            loader.hide();
          });
      } else {
        this.snackbar.snackbarText = "Fill required fields!";
        this.snackbar.visible = true;
      }
    }
  }
};
</script>

<style>
</style>
